module.exports = __webpack_public_path__ + "images/8de2eaa4f6496023ab7deada559c9069.png";